export function locationsQuery(params) {
    return JSON.stringify({
        query: `
            query Locations(
                $regionId: ID,
                $includingListings: Boolean,
            ) {
                locations(
                    regionId: $regionId,
                    includingListings: $includingListings,
                )  {
                    id
                    name
                    type
                    ... on Location {
                        regionID
                    }
                }
            }
        `,
        variables: params,
    });
}
